import React from 'react';

import styled from 'styled-components';

import NoJobFunctionOrRole from 'assets/images/NoJobFunctionOrRole.png';

import theme from 'constants/theme';

import { Typography13, Typography14 } from 'uiToolkit/Typography';

const Container = styled.div`
  padding: 0 1.5rem;
`;

const StyledImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  margin-top: 40px;
  margin-bottom: 40px;
`;

const JobFunctionRoleError = () => (
  <Container>
    <StyledImage src={NoJobFunctionOrRole} alt="No Job Function or role found" />
    <Typography14 color={theme.palette.text.blackv1} weight={600} bottomGutter={2.5} align="center">
      Your function and/or role aren't set in Mesh!
    </Typography14>
    <Typography13 color={theme.palette.text.blackv1} weight={600} align="center">
      Please contact your HR administrator to get this fixed
    </Typography13>
  </Container>
);

export default JobFunctionRoleError;
